/* import { useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

export default function Register() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleRegister = async () => {
    setError("");

    if (!userName || !email || !password) {
      setError("All fields are required");
      return;
    }

    
  try {
  await API.post(
    "/auth/register",
    {
      userName,
      password,
      email,
    },
    {
      withCredentials: true,
    }
  );

  navigate("/projects");
}
catch (err: any) {
  console.error(err);
  setError("Registration failed");
}
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 px-4">
      <div className="bg-white p-6 shadow rounded w-full max-w-sm space-y-4">

        <h2 className="text-xl font-semibold text-center">
          Create Account
        </h2>

       
        <input
          placeholder="Username"
          className="border p-2 w-full rounded"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
        />

     
        <input
          placeholder="Email"
          className="border p-2 w-full rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

       
        <input
          type="password"
          placeholder="Password"
          className="border p-2 w-full rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        
        {error && (
          <div className="text-red-600 text-sm">{error}</div>
        )}

       
        <button
          onClick={handleRegister}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          Register
        </button>

       
        <button
          onClick={() => navigate("/login")}
          className="text-sm text-gray-600 hover:underline w-full text-center"
        >
          Already have an account? Login
        </button>

      </div>
    </div>
  );
} 
  */
 import { useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";

export default function Register() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  /* const handleRegister = async () => {
    setError("");

    if (!userName || !email || !password) {
      setError("All fields are required");
      return;
    }

    try {
      setLoading(true);

      await API.post(
        "/auth/register",
        {
          userName,
          password,
          email,
        },
        {
          withCredentials: true,
        }
      );

      setLoading(false);
      setShowOtp(true);
    } catch (err: any) {
      setLoading(false);
      console.error(err);
      setError(err.response?.data ?? "Registration failed");
    }
  }; */
  const handleRegister = async () => {
  setError("");

  if (!userName || !email || !password) {
    setError("All fields are required");
    return;
  }

  // GA4 event fires only when all required fields are filled
  ReactGA.event("mbim_registered", {
    registration_method: "email",
  });

  try {
    setLoading(true);

    await API.post(
      "/auth/register",
      {
        userName,
        password,
        email,
      },
      {
        withCredentials: true,
      }
    );

    setLoading(false);
    setShowOtp(true);
  } catch (err: any) {
    setLoading(false);
    console.error(err);
    setError(err.response?.data ?? "Registration failed");
  }
};

  const handleVerifyOtp = async () => {
    try {
      const res = await API.post(
        "/auth/verify-email",
        {
          email,
          otp,
        },
        {
          withCredentials: true,
        }
      );
      
    
setSuccess("✓ OTP verified successfully.\n✓ Registration completed successfully.");

setTimeout(() => {
  navigate("/login");
}, 2000);
    } catch (err: any) {
      console.error(err);
      setError(err.response?.data ?? "Invalid OTP");
    }
  };
  // 👇 ADD THIS HERE
const handleResendOtp = async () => {
  try {
    setError("");
    setSuccess("");
    setOtp("");

    const res = await API.post(
      "/auth/resend-email-otp",
      {
        email,
      },
      {
        withCredentials: true,
      }
    );

    alert(res.data.message);
  } catch (err: any) {
    console.error(err);
    setError(err.response?.data ?? "Failed to resend OTP");
  }
};

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 px-4">
      <div className="bg-white p-6 shadow rounded w-full max-w-sm space-y-4">

        <h2 className="text-xl font-semibold text-center">
          Create Account
        </h2>

        {!showOtp ? (
          <>
            <input
              placeholder="Username"
              className="border p-2 w-full rounded"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />

            <input
              placeholder="Email"
              className="border p-2 w-full rounded"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="password"
              placeholder="Password"
              className="border p-2 w-full rounded"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {error && (
              <div className="text-red-600 text-sm">{error}</div>
            )}

            <button
              onClick={handleRegister}
              disabled={loading}
              className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
            >
              {loading ? "Sending OTP..." : "Register"}
            </button>
          </>
        ) : (
          <>
            <p className="text-sm text-gray-600">
              An OTP has been sent to <b>{email}</b>
            </p>

            <input
              placeholder="Enter OTP"
              className="border p-2 w-full rounded"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            {/* Add this here */}
{success && (
  <div className="bg-green-100 border border-green-400 text-green-700 px-3 py-2 rounded text-sm whitespace-pre-line">
    {success}
  </div>  
)}

            {error && (
              <div className="text-red-600 text-sm">{error}</div>
            )}

            <button
              onClick={handleVerifyOtp}
              className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700"
            >
              Verify OTP
            </button>

            <button
  onClick={handleResendOtp}
  className="w-full mt-2 border border-blue-600 text-blue-600 py-2 rounded hover:bg-blue-50"
>
  Resend OTP
</button>
          </>
        )}

        <button
          onClick={() => navigate("/login")}
          className="text-sm text-gray-600 hover:underline w-full text-center"
        >
          Already have an account? Login
        </button>

      </div>
    </div>
  );
}